export default __webpack_public_path__ + "static/media/2334.d6775dac.png";